import { GetCompanyResourceDataResponse } from '../../Models/axiosModel'
import { Grid } from '@mui/material'
import styles from "../../Styles/ComponentStyles/TrainingPageStyles/Training.module.scss"

export interface SelectedResourceData {
    selectedResourceData: GetCompanyResourceDataResponse
}

const ResourceViewComponent = (props: SelectedResourceData) => {
    const { selectedResourceData } = props

    // Get the file URL from the resource data
    const fileUrl = selectedResourceData?.resource_file_data[0]?.file_url
    const iframeTitle = `Resource viewer: ${selectedResourceData?.resource_title ?? 'Untitled'} (${selectedResourceData?.resource_id ?? 'no-id'})`

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} className={styles.resourceIframeItem}>
                                <iframe
                                    id="tabula"
                                    className="tabula_class"
                                    title={iframeTitle}
                                    src={`${fileUrl}`}
                                    height={700}
                                    width="100%"
                                    allowFullScreen
                                    style={{ width: "100%" }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ResourceViewComponent